import { Job } from './job';

export class JobLocation {
  id: number;
  city: string;
  state: string;
  jobs: Job[];
}

